import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { IconCreateBlack } from '../../../assets';
import { PROMOTION } from '../../../constants/define/translation';

interface TourTrashPageHeaderProps {
  setIsOpenModal: Function;
  extraDropdown?: any;
}

export const PromotionPageHeader = (props: TourTrashPageHeaderProps) => {
  const { t } = useTranslation(PROMOTION);
  const { extraDropdown } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.buttonCreate'),
      bgWhite: 'true',
      onClick: () => props.setIsOpenModal(true),
      icon: <IconCreateBlack />,
    },
  ];

  return <ContentPageHeader title={t('header.title')} extra={extra} extraDropdown={extraDropdown} />;
};
